import universal from 'react-universal-component';

export default universal(() => import('./DepthCharts'));



// WEBPACK FOOTER //
// ./src/app/views/DepthCharts/index.js